module.exports = __webpack_public_path__ + "static/media/22.eefd0b47.jpg";